










































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  queryCurrent,
  withdraw,
  detail,
  teamForum,
  getTeamDetail,
  joinTeam,
} from "@/api/team/team";
import { SERVER_HOST, DOMAIN } from "@/global/constants";
import { parseUrlParams } from "@/global/utils";
import Tab from "@/components/tab.vue";
// 此组件按需加载
const Info = () => import("@/components/team/info.vue");
const Member = () => import("@/components/team/member.vue");
const Apply = () => import("@/components/team/apply.vue");
const Statistics = () => import("@/components/team/statistics.vue");
const Group = () => import("@/components/team/group.vue");

@Component({
  components: {
    Info,
    Member,
    Statistics,
    Apply,
    Group,
    Tab,
  },
})
export default class MyTeamDetail extends Vue {
  private tabList: object[] = [
    {
      value: "info",
      label: "团队详情",
      key: "1",
    },
    {
      value: "group",
      label: "小队管理",
      key: "2",
    },
    {
      value: "member",
      label: "成员管理",
      key: "3",
    },
    {
      value: "statistics",
      label: "成员做题详情",
      key: "4",
    },
    // {
    //   value: "apply",
    //   label: "入会审批",
    //   key: "5",
    // },
  ];
  private current: string = "info";
  private logoImg: string =
    "https://task.totoro.cdn.shandianshua.com/o_1ctuk2ugadekrabb0p178mkqc9.jpg";
  private shareUrl: string = "";
  private team: any = {};
  private selectTeam: any = {};
  private searchParams: object = {
    team_id: "",
  };
  private loading: boolean = false;
  get userInfo() {
    return this.$store.state.userInfo;
  }

  private created() {
    this.loading = true;
    this.team = this.$store.state.team;
    this.getTeam();
  }
  private async getTeam() {
    try {
      const res = await detail();
      this.$nextTick(() => {
        this.team = Object.assign(this.team, res);
      });
      this.$store.commit("setTeam", res);
    } catch (err) {
      console.log(err);
    }
    try {
      const res2 = await teamForum();
      this.$nextTick(() => {
        this.team = Object.assign(this.team, res2);
      });
      this.$store.commit("setTeamForum", res2);
      this.loading = false;
      this.init();
    } catch (err) {
      console.log(err);
    }
  }

  private init() {
    let params: any = parseUrlParams(window.location.search);
    if (params.tid !== undefined) {
      queryCurrent(params.tid, undefined);
      queryCurrent(undefined, undefined);
    }

    if (this.userInfo && this.userInfo.offline_leader == false) {
      this.tabList.splice(1, 2);
    }
    if (this.team !== null) {
      if (this.team.logo !== undefined) {
        if (this.team.logo.split("").slice(0, 4).join() == "h,t,t,p") {
          this.logoImg = this.team.logo;
        }
      }
    }
    let location_h = window.location.href.split(".")[0];
    this.shareUrl =
      `http://team.longmaosoft.com/user/login/` + this.team.team_id;
    if (location_h == "http://dev" || location_h == "https://dev") {
      this.shareUrl =
        `http://dev.team.longmaosoft.com?tid=` + this.team.team_id;
    }
  }
  private async handleSearch() {
    let params: any = JSON.parse(JSON.stringify(this.searchParams));
    const res = await getTeamDetail(params);
    this.$nextTick(() => {
      this.selectTeam = res;
    });
  }

  private async joinTeam() {
    if (this.selectTeam.tid) {
      let params: any = JSON.parse(JSON.stringify(this.selectTeam));
      let res: any = await joinTeam(params);
      if (res.code == "200") {
        this.$store.dispatch("getTeam");
        this.$Message.success("公会申请成功，请等待团队长审批");
        this.loading = true;
        this.team = this.$store.state.team;
        if (!(this.team && this.team.team_id)) {
          this.getTeam();
        } else {
          this.loading = false;
          this.init();
        }
      } else {
         this.$Message.error(res.message);
      }
    }
  }

  private changeTag(type) {
    this.current = type;
    console.log(type);
  }
  private showConfirm() {
    this.$Modal.confirm({
      title: "撤销申请",
      content: `撤销申请后，将自动退出平台登陆`,
      okText: "撤销申请",
      cancelText: "取消",
      onOk: () => {
        this.handleRevoke();
      },
    });
  }
  // 撤销申请
  private async handleRevoke() {
    let res = await withdraw({ tid: this.team.team_id });
    this.$store.dispatch("logoutUser");
  }
}
